import React, {useEffect, useRef, useState} from 'react'
import {connect} from 'react-redux'
import {postPersonel, getTemplateExcelPersonel, uploadFilePersonel, getPersonel} from 'actions/procedureDefActions';
import {getStaffArchive, editPersonelArchive} from 'actions/ProcedurePricingActions'
import SendFile from 'components/common/sendFile'
import Spinner from 'components/common/Spinner';
// reactstrap components
import {
    Row, Col,
    Button,
    FormGroup, Form, Input,
    Modal
} from "reactstrap";
import ReactDatetime from "react-datetime";
import CreatableSelect from "react-select/creatable";
import {deletePersonel, editPersonel} from "../../../actions/procedureDefActions";
import EditButton from "../../../components/medicalProceduresComponents/EditButton";
import DeleteButton from "../../../components/medicalProceduresComponents/DeleteButton";
import ArchiveButton from "../../../components/medicalProceduresComponents/ArchiveButton";
import PersonelArchiveTable from 'components/medicalProceduresComponents/PersonelArchiveTable';
import {getCurrentUser} from 'actions/userActions';

import moment from 'moment';

const Personel = (props) => {
    const valueConvert = (val) => {
        let nr = Number(val).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".", ",")
        return nr === "NaN" || nr==='0,00' ? " X " : nr
    }
    const displayDate = (date) => {
        return date==='1900-01-01'?'':date
    }
    const [modalMini, setModalMini] = React.useState(false);
    const toggleModalMini = () => {
        setModalMini(!modalMini);
    };
    const [alertText, setAlertText] = React.useState("")
    const selectPersonel = useRef(null)
    const {personel, postPersonel, opk, categories, postAvailablePersonel, 
        typeLoading, editPersonel, deletePersonel, newPersonelCat, 
        getTemplateExcelPersonel, uploadFilePersonel,  errorFileMaterial, loadingFileMaterial, getPersonel,
        getStaffArchive, staff_archive, editPersonelArchive, archive_loading,
        getCurrentUser, currentUser
    } = props
    const [formValues, setFormValues] = React.useState({
        "rate_hour": '',
        "rate_min": '',
        "rate_proc": '',
        "staff_type": '',
        "procedurestaff_opk": '',
        'date_staff':''
    })
    const [formValuesEdit, setFormValuesEdit] = React.useState({
        "rate_hour_edit": '',
        "rate_min_edit": '',
        "rate_proc_edit": '',
        "staff_type_edit": '',
        "procedurestaff_opk_edit": '',
        'date_staff':''
    })
    const [idtoEdit, setIdEdit] = React.useState(null)
    const seIdelement = (elem) => {
        let temp = {
            rate_hour_edit: elem.rate_hour,
            rate_min_edit: elem.rate_min,
            rate_proc_edit: elem.rate_proc,
            staff_type_edit: elem.staff_type,
            procedurestaff_opk_edit: elem.procedurestaff_opk,
            date_staff_edit: elem.date_staff=='1900-01-01'?'':elem.date_staff
        }
        setIdEdit(elem.id, setFormValuesEdit(temp))
    }
    const [archiveModal, setArchiveModal] = useState(false)
    const toggleArchiveModal = () => {
        setArchiveModal(!archiveModal)
    }
    const showArchive = (id) => {
        getStaffArchive(id)
        setArchiveModal(true)
    }
    React.useEffect(()=>{
        getCurrentUser()
    },[])

    const handleFieldChange = (e) => {
        const fieldValue = e.target.value;
        const fieldIndex = e.target.id

        setFormValues((prevState) => {
            const prevLoginValues = {...prevState};
            prevLoginValues[fieldIndex] = fieldValue;
            return prevLoginValues;
        });
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        if(formValues['rate_proc']==='' && formValues['rate_hour'] !== "") formValues['rate_proc']=0
        if(formValues['rate_hour']==='' && formValues['rate_proc'] !== "") {formValues['rate_hour']=0; formValues['rate_min']=0}
        if (formValues.rate_hour === '' || formValues.rate_min === '' || formValues.rate_proc === '' || formValues.staff_type === '' || formValues.procedurestaff_opk === '' || formValues['date_staff'] === '' || formValues['date_staff'] === "Invalid date") {
            setAlertText("Wszystkie pola muszą być uzupełnione!", toggleModalMini());
            return 0
        }
        postPersonel(formValues)
        selectPersonel.current.select.select.clearValue()
        setFormValues({
            "rate_hour": '',
            "rate_min": '',
            "rate_proc": '',
            "staff_type": '',
            "procedurestaff_opk": '',
            "date_staff": ''
        })
    }
    const changeStawka = (e) => {
        const fieldValue = e.target.value;
        const fieldIndex = e.target.id

        setFormValues((prevState) => {
            const prevLoginValues = {...prevState};
            prevLoginValues['rate_min'] = (fieldValue / 60).toFixed(2);
            return prevLoginValues;
        });
    }
    const changeStawkaEdit = (e) => {
        const fieldValue = e.target.value;
        const fieldIndex = e.target.id

        setFormValuesEdit((prevState) => {
            const prevLoginValues = {...prevState};
            prevLoginValues['rate_min_edit'] = (fieldValue / 60).toFixed(2);
            return prevLoginValues;
        });
    }

    const handleCreateUnit = (newUnit) => {
        postAvailablePersonel({"name": newUnit})
    }
    React.useEffect(()=>{
        if(newPersonelCat!==null){
            setFormValues((prevState) => {
                    const prevLoginValues = {...prevState};
                    prevLoginValues["staff_type"] =newPersonelCat.id;
                    return prevLoginValues;
            });
        }
    },[newPersonelCat])

    const [displayUnit, setDisplayUnit] = useState(['Wybierz'])
    useEffect(() => {
        if (categories && categories.length > 0) {
            setDisplayUnit(categories.map(material => {
                return {"label": material.name, "value": material.id}
            }))
        }
    }, [categories])

    const submitEdit = (values, id) => {
        const ValuesToSend = Object.assign({},values)
        Object.keys(ValuesToSend).map(key => delete Object.assign(ValuesToSend, {[key.replace("_edit", "")]: values[key]})[key])

        if(ValuesToSend['rate_proc']==='' && ValuesToSend['rate_hour'] !== "") ValuesToSend['rate_proc']=0
        if(ValuesToSend['rate_hour']==='' && ValuesToSend['rate_proc'] !== "") {ValuesToSend['rate_hour']=0; ValuesToSend['rate_min']=0}
        if (ValuesToSend.rate_hour === '' || ValuesToSend.rate_min === '' || ValuesToSend.rate_proc === '' || ValuesToSend.staff_type === '' || ValuesToSend.procedurestaff_opk === '' || ValuesToSend['date_staff'] === '' ||ValuesToSend['date_staff']==="Invalid date") {
            setAlertText("Wszystkie pola muszą być uzupełnione!", toggleModalMini());
            return 0
        }

        editPersonel(ValuesToSend, id)
        setIdEdit(null)
    }
    const editArchive = (values, id) => {
        const ValuesToSend = values
        Object.keys(ValuesToSend).map(key => delete Object.assign(ValuesToSend, {[key.replace("_edit", "")]: values[key]})[key])
        // console.log(ValuesToSend)
        if(ValuesToSend['rate_proc']==='' && ValuesToSend['rate_hour'] !== "") ValuesToSend['rate_proc']=0
        if(ValuesToSend['rate_hour']==='' && ValuesToSend['rate_proc'] !== "") {ValuesToSend['rate_hour']=0; ValuesToSend['rate_min']=0}
        if (ValuesToSend.rate_hour === '' || ValuesToSend.rate_min === '' || ValuesToSend.rate_proc === '' || ValuesToSend.staff_type === '' || ValuesToSend.procedurestaff_opk === '' || ValuesToSend['date_staff'] === '' ||ValuesToSend['date_staff']==="Invalid date") {
            setAlertText("Wszystkie pola muszą być uzupełnione!", toggleModalMini());
            return 0
        }
        editPersonelArchive(ValuesToSend, id)
        // setIdEdit(null)
    }

    const changeValueInEditForm = (e) => {
        if (e.target.id === "rate_hour_edit") {
            setFormValuesEdit((prevState) => {
                const prevLoginValues = {...prevState};
                prevLoginValues['rate_min_edit'] = (e.target.value / 60).toFixed(2);
                return prevLoginValues;
            });
        }
        setFormValuesEdit((prevState) => {
            const prevLoginValues = {...prevState};
            prevLoginValues[e.target.id] = e.target.value;
            return prevLoginValues;
        });

    }
    const getTempalte = () => {
        getTemplateExcelPersonel()
    }

    const handleSubmitFile = (file) => {
        if(!file.file){console.log('brak pliku'); return 0}
        const formData = new FormData();
        formData.append( `file`, file.file );
        formData.append( `name`, file.name);
        uploadFilePersonel(formData)
    }
    const usePrevious = (value) => {
        const ref = useRef();
        useEffect(() => {
          ref.current = value;
        //eslint-disable-next-line
        });
        return ref.current;
      }
    const prevCount = usePrevious(loadingFileMaterial)
      useEffect(()=>{
        if(loadingFileMaterial){setShowModal(true)}
        if(prevCount||!archive_loading) getPersonel()   
    },
    [loadingFileMaterial, archive_loading])

    const [ShowModal, setShowModal] = useState(false)
    const toggleModalMiniFile = () => {
        setShowModal(!ShowModal);
    };
    return (
        <div className="content">
            <div>
            <SendFile getTemplate={getTempalte} handleSubmitFile={handleSubmitFile} currentUser={currentUser}></SendFile><br/><br/>

                {formValues && <Form className="settings-form okraglaczki" onSubmit={(e) => handleSubmit(e)}>
                    <Row>
                        <Col md="4" sm="14">

                            <FormGroup>
                                <label htmlFor={'procedurestaff_opk'}>{`${"Numer OPK"}`}</label>
                                {/* <Input
                        className="border-input"
                        placeholder={`${"Numer opk"}`}
                        type="text"
                        id="procedurestaff_opk"
                        value={formValues['procedurestaff_opk']}
                        onChange={(e)=>handleFieldChange(e)}
                    /> */}
                                <Input type="select" name="opk" placeholder="wybierz opk" id="procedurestaff_opk"
                                       value={formValues['procedurestaff_opk']} onChange={(e) => handleFieldChange(e)}>
                                    <option value=''></option>
                                    {opk && Object.entries(opk).sort((a,b)=>{ return a[1] > b[1]}).map(([key, value], i) => {
                                        return <option value={key}>{value}</option>
                                    })}
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col md="3" sm="12">
                            <FormGroup>
                                <label>{`${"Kategoria personelu"}`}</label>
                                {/* <Input
                        className="border-input"
                        placeholder={`${"kategoria personelu"}`}
                        type="text"
                        id="staff_type"
                        value={formValues['staff_type']}
                        onChange={(e)=>handleFieldChange(e)}

                    /> */}
                                <CreatableSelect className="bigRadius select-wycena"
                                    ref={selectPersonel}
                                    isDisabled={typeLoading}
                                    isLoading={typeLoading}
                                    placeholder={"Wybierz..."}
                                    aria-label={"Wybierz kategorię personelu"}
                                    formatCreateLabel={function formatCreateLabel(inputValue) {
                                        return "Dodaj \"".concat(inputValue, "\"");
                                    }}
                                    onChange={e => {
                                        setFormValues((prevState) => {
                                            if (e !== null) {
                                                // setDisplayUnit(e.label)
                                                const prevLoginValues = {...prevState};
                                                prevLoginValues["staff_type"] = e.value;
                                                return prevLoginValues;
                                            }
                                        });

                                    }}
                                    onCreateOption={e => handleCreateUnit(e)}
                                    options={displayUnit}
                                    value={displayUnit.find(item => item.value === formValues['staff_type'])}
                                />
                                {/*<Input type="select" name="staff_type" id="staff_type" value={formValues['staff_type']} onChange={(e)=>handleFieldChange(e)}>*/}
                                {/*    <option value=''></option>*/}
                                {/*    {opk && categories.map((elem)=>{*/}
                                {/*      return <option value={elem.id}>{elem.name}</option>*/}
                                {/*    })}*/}
                                {/*  </Input>*/}
                            </FormGroup>
                        </Col>
                        <Col md="1" sm="12">
                            <FormGroup>
                                <label htmlFor={'rate_hour'}>{`${"Stawka(zł/godz.)"}`}</label>
                                <Input
                                    className="border-input"
                                    placeholder={`${"zł/godz."}`}
                                    type="number"
                                    min='0'
                                    step='0.01'
                                    id="rate_hour"
                                    value={formValues['rate_hour']}
                                    onChange={(e) => {
                                        handleFieldChange(e);
                                        changeStawka(e)
                                    }}
                                />

                            </FormGroup>
                        </Col>
                        <Col md="1" sm="12">
                            <FormGroup>
                                <label htmlFor={'rate_min'}>{`${"Stawka(zł/min)"}`}</label>
                                <Input
                                    className="border-input"
                                    placeholder={`${"zł/min"}`}
                                    type="number"
                                    min='0'
                                    step='0.01'
                                    id="rate_min"
                                    value={formValues['rate_min']}
                                    disabled
                                    onChange={(e) => handleFieldChange(e)}

                                />
                            </FormGroup>
                        </Col>
                        <Col md="1" sm="12">
                            <FormGroup>
                                <label htmlFor={'rate_proc'}>{`${"Stawka(zł/proc.)"}`}</label>
                                <Input
                                    className="border-input"
                                    placeholder={`${"zł/proc."}`}
                                    type="number"
                                    min='0'
                                    step='0.01'
                                    id="rate_proc"
                                    value={formValues['rate_proc']}
                                    onChange={(e) => handleFieldChange(e)}

                                />
                            </FormGroup>
                        </Col>
                        <Col md="2" className='p-0'>
                            <Row className='m-0'>
                                <Col md="8" sm="12" className='p-0'>
                                    <FormGroup>
                                        <label htmlFor={'date_staff'} style={{marginLeft:"7%"}}>{`${"Data"}`}</label>
                                        <ReactDatetime
                                                inputProps={{
                                                    className: "form-control",
                                                    placeholder: "data obowiązywania",
                                                    'aria-label': "data obowiązywania",
                                                }}
                                                dateFormat={"YYYY-MM-DD"}
                                                timeFormat={false}
                                                locale="pl"
                                                id='date_staff'
                                                onChange={(e) => {
                                                    handleFieldChange({'target': {value: moment(e).format('YYYY-MM-DD'), id: 'date_staff'}})
                                                }}
                                                value={formValues['date_staff']}
                                                className='dateSelectWycena'
                                            />
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup style={{textAlign:"center"}}>
                                        <label>{`${"Dodaj"}`}</label> <br/>
                                        <Button style={{width:"60px"}}
                                            className="btn m-0 btn-round"
                                            color="wycena"
                                            type="submit" outline
                                            aria-label={'Dodaj'}
                                            disabled={currentUser && currentUser.company === null}

                                        >
                                            {/* <i className="far fa-plus-square fa-2x"  ></i> */}
                                            <i className='nc-icon nc-simple-add'></i>
                                        </Button>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>


                    </Row>
                </Form>}
            </div>
            <table className='table table-border tableWycena'>
                <thead className=''>
                <tr className=''>
                    <th className="headerColor">Numer OPK proceduralnego</th>
                    <th className="headerColor">Kategoria personelu</th>
                    <th className="headerColor">Średnia stawka w zł/godz.<br></br>(brutto z pochodnymi)</th>
                    <th className="headerColor">Średnia stawka w zł/minuta<br></br>(brutto z pochodnymi)</th>
                    <th className="headerColor">Średnia stawka w zł/procedurę<br></br>(brutto z pochodnymi)</th>
                    <th className="headerColor">Data obowiązywania</th>
                    <th className="headerColor">Opcje</th>
                </tr>
                </thead>
                <tbody>
                {personel && personel.map((elem) => {
                    return <>
                        {idtoEdit !== elem.id ? <tr>
                            <td>{opk ? opk[elem.procedurestaff_opk] : ""}</td>
                            <td>{[elem.staff_name]}</td>
                            <td className='rightAlignCell'>{valueConvert(elem.rate_hour)}</td>
                            <td className='rightAlignCell'>{valueConvert(elem.rate_min)}</td>
                            <td className='rightAlignCell'>{valueConvert(elem.rate_proc)}</td>
                            <td className='rightAlignCell'>{displayDate(elem.date_staff)}</td>
                            {idtoEdit !== elem.id ? <td  style={{whiteSpace:'nowrap'}} className='text-center'>
                                <ArchiveButton idx={elem.id} elem={elem} showArchive={showArchive}/> 
                                <EditButton idx={elem.id} elem={elem} edit={seIdelement}/>
                                <DeleteButton idx = {elem.id}
                                id={elem.id}
                                deleteFunc={deletePersonel}
                                text={"zasób osobowy?"}/></td>: <td>
                    <span style={{marginRight: "5px", cursor: "pointer"}} onClick={() => {
                        setIdEdit(null)
                    }}>
                    Anuluj</span>&nbsp;&nbsp;<span style={{marginLeft: "5px"}}>OK</span></td>}
                        </tr> : <tr>
                            <td>
                                <Input type="select" name="opk" placeholder="wybierz opk" id="procedurestaff_opk_edit"
                                       value={formValuesEdit['procedurestaff_opk_edit']}
                                       onChange={(e) => changeValueInEditForm(e)}>
                                    <option value=''></option>
                                    {opk && Object.entries(opk).map(([key, value], i) => {
                                        return <option value={key}>{value}</option>
                                    })}
                                </Input>
                            </td>
                            <td><CreatableSelect 
                                className='select-wycena'
                                isDisabled={typeLoading}
                                isLoading={typeLoading}
                                placeholder={"Wybierz..."}
                                formatCreateLabel={function formatCreateLabel(inputValue) {
                                    return "Dodaj \"".concat(inputValue, "\"");
                                }}
                                onChange={e => {
                                    setFormValuesEdit((prevState) => {
                                        // setDisplayUnit(e.label)
                                        const prevLoginValues = {...prevState};
                                        prevLoginValues["staff_type_edit"] = e.value;
                                        return prevLoginValues;
                                    });

                                }}
                                onCreateOption={e => handleCreateUnit(e)}
                                options={displayUnit}
                                value={displayUnit.find(item => item.value === formValuesEdit['staff_type_edit'])}
                            />
                            </td>
                            <td><Input
                                className="border-input"
                                type="number"
                                id="rate_hour_edit"
                                value={formValuesEdit['rate_hour_edit']}
                                onChange={(e) => {
                                    changeValueInEditForm(e)
                                    changeStawkaEdit(e)
                                }}

                            /></td>
                            <td><Input
                                className="border-input"
                                type="text"
                                id="rate_min_edit"
                                value={formValuesEdit['rate_min_edit']}
                                disabled

                            /></td>
                            <td className='rightAlignCell'><Input
                                className="border-input"
                                type="number"
                                id="rate_proc_edit"
                                value={formValuesEdit['rate_proc_edit']}
                                onChange={(e) => {
                                    changeValueInEditForm(e)
                                }}

                            /></td>
                            <td> <ReactDatetime
                                inputProps={{
                                    className: "form-control",
                                    placeholder: "data obowiązywania",
                                }}
                                dateFormat={"YYYY-MM-DD"}
                                timeFormat={false}
                                locale="pl"
                                id='date_staff_edit'
                                onChange={(e) => {
                                    changeValueInEditForm({'target': {value: moment(e).format('YYYY-MM-DD'), id: 'date_staff_edit'}})
                                }}
                                value={formValuesEdit['date_staff_edit']}
                                className='dateSelectWycena'
                            /></td>
                            <td style={{whiteSpace:'nowrap'}} className='text-center'>
                                <Button
                                    className="btn-link "
                                    color="danger"
                                    data-toggle="tooltip"
                                    size="sm"
                                    type="button"
                                    onClick={() => {
                                        setIdEdit(null)
                                    }}
                                >
                                    <i className="fas fa-times"></i>
                                </Button>

                                <Button
                                    className="btn-link "
                                    color="success"
                                    data-toggle="tooltip"
                                    size="sm"
                                    type="button"
                                    onClick={(e) => {
                                        submitEdit(formValuesEdit, idtoEdit)
                                    }}
                                >
                                    <i className="fas fa-check"></i>
                                </Button>


                            </td>
                        </tr>}

                    </>
                })}
                </tbody>
            </table>
            <Modal
                className="modal-sm"
                modalClassName="modal-primary"
                isOpen={modalMini}
                toggle={toggleModalMini}
            >
                <div className="modal-header justify-content-center">
                    <div className="modal-profile ml-auto mr-auto">
                        <i className="nc-icon nc-bulb-63"/>
                    </div>
                </div>
                <div className="modal-body">
                    <p>{alertText}</p>
                </div>
                <div className="modal-footer">
                        <Button
                            className='btn-link'
                            color="wycena"
                            data-dismiss="modal"
                            type="button"
                            onClick={toggleModalMini}
                        >
                            Zamknij
                        </Button>
                </div>
            </Modal>
            <Modal
             className="modal-sm"
             modalClassName="modal-primary"
             isOpen={ShowModal}
             toggle={toggleModalMiniFile}
             >
                 <div className="modal-header justify-content-center">
                    <div className="modal-profile ml-auto mr-auto">
                        <i className="nc-icon nc-bulb-63"/>
                    </div>
                </div>
                <div className="modal-body">
                    <p style={{textAlign:"center"}}>{loadingFileMaterial? <><Spinner/></>:<>
                    {errorFileMaterial ?<>Wystąpił błąd, sprawdź wprowadzane dane i spróbuj ponownie.</>:<>Pomyślnie zaimportowano dane!</>}
                    </>}</p>
                </div>
                <div className="modal-footer">
                        <Button
                            className='btn-link'
                            color="wycena"
                            data-dismiss="modal"
                            type="button"
                            onClick={e => {
                                toggleModalMiniFile();
                            }}>
                            Zamknij
                        </Button>
                </div>
            </Modal>
            <Modal
                size='xl'
                modalClassName="modal-primary"
                isOpen={archiveModal}
                toggle={toggleArchiveModal}
                >
                 <div className="modal-header justify-content-center">
                    <div className="modal-profile ml-auto mr-auto">
                        <i className="far fa-file-archive"/> 
                    </div>
                </div>
                <div className="modal-body">
                    <PersonelArchiveTable personel={staff_archive} opk={opk} submitEdit={editArchive}
                        displayUnit={displayUnit} typeLoading={typeLoading} handleCreateUnit={handleCreateUnit} />
                </div>
                <div className="modal-footer">
                    <Button
                        className='btn-link'
                        color="wycena"
                        style={{width: '100%'}}
                        data-dismiss="modal"
                        type="button"
                        onClick={e => {
                            toggleArchiveModal()
                        }}>
                        Zamknij
                    </Button>
                </div>
            </Modal>
        </div>
    )
}
const mapStateToProps = state => ({
    errorFileMaterial: state.procedureDefReducer.errorFileMaterial,
    loadingFileMaterial: state.procedureDefReducer.loadingFileMaterial,
    staff_archive: state.ProcedurePricingReducer.staff_archive,
    archive_loading: state.ProcedurePricingReducer.archive_loading,
    currentUser: state.UserReducer.currentUser

})
export default connect(mapStateToProps, {getCurrentUser, editPersonel, postPersonel, deletePersonel, getTemplateExcelPersonel, uploadFilePersonel, getPersonel, getStaffArchive, editPersonelArchive})(Personel);
